/**
 * en-GB messages added by Phase 1 task W2 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w2EnGB = {
    // List page
    'membersUi.title': 'Members',
    'membersUi.description': 'The people in this group: add them one by one, or import a spreadsheet.',
    'membersUi.table': 'Members of this group',
    'membersUi.add': 'Add member',
    'membersUi.import': 'Import',
    'membersUi.search': 'Search members',
    'membersUi.statusFilter': 'Show',
    'membersUi.status.current': 'Current',
    'membersUi.status.archived': 'Archived',
    'membersUi.status.all': 'All',
    'membersUi.col.name': 'Name',
    'membersUi.col.email': 'Email',
    'membersUi.col.phone': 'Phone',
    'membersUi.col.role': 'Role',
    'membersUi.col.details': 'Details',
    'membersUi.col.status': 'Status',
    'membersUi.columns': 'Columns',
    'membersUi.selectAll': 'Select all on this page',
    'membersUi.selectOne': 'Select {name}',
    'membersUi.selected': '{count} selected',
    'membersUi.bulk.archive': 'Archive',
    'membersUi.bulk.restore': 'Restore',
    'membersUi.bulk.delete': 'Delete',
    'membersUi.bulk.setField': 'Set a field',
    'membersUi.bulk.field': 'Field',
    'membersUi.bulk.value': 'Value',
    'membersUi.bulk.apply': 'Apply',
    'membersUi.bulk.result': '{updated} updated, {skipped} skipped.',
    'membersUi.empty': 'No members yet.',
    'membersUi.archivedBadge': 'Archived',
    'membersUi.currentBadge': 'Current',
    // Member drawer
    'membersUi.drawer.new': 'Add member',
    'membersUi.drawer.edit': 'Edit {name}',
    'membersUi.drawer.close': 'Close',
    'membersUi.field.fullName': 'Full name',
    'membersUi.field.email': 'Email',
    'membersUi.field.phone': 'Phone',
    'membersUi.field.role': 'Role',
    'membersUi.field.externalId': 'Your reference',
    'membersUi.field.externalId.hint': 'For example an employee number. Used to match rows when you import.',
    'membersUi.field.startDate': 'Start date',
    'membersUi.field.endDate': 'End date',
    'membersUi.personalFields': 'Personal fields',
    'membersUi.sensitive': 'Sensitive field',
    'membersUi.sensitive.locked': 'You do not have permission to see or change this field.',
    'membersUi.created': 'Member added.',
    'membersUi.updated': 'Member saved.',
    'membersUi.archive': 'Archive member',
    'membersUi.restore': 'Restore member',
    'membersUi.archived': 'Member archived.',
    'membersUi.restored': 'Member restored.',
    'membersUi.photo': 'Photo',
    'membersUi.photo.set': 'A photo is set.',
    'membersUi.photo.none': 'No photo yet.',
    'membersUi.photo.choose': 'Member photo',
    'membersUi.photo.remove': 'Remove photo',
    'membersUi.photo.saved': 'Photo saved.',
    'membersUi.photo.removed': 'Photo removed.',
    'membersUi.pin': 'Kiosk PIN',
    'membersUi.pin.hint': 'Four digits.',
    'membersUi.pin.label': 'New PIN',
    'membersUi.pin.set': 'Set PIN',
    'membersUi.pin.remove': 'Remove PIN',
    'membersUi.pin.has': 'A PIN is set.',
    'membersUi.pin.none': 'No PIN is set.',
    'membersUi.pin.invalid': 'The PIN must be exactly four digits.',
    'membersUi.pin.saved': 'PIN saved.',
    'membersUi.pin.removed': 'PIN removed.',
    'membersUi.deleted': 'Member deleted.',
    // Import wizard
    'membersUi.import.title': 'Import members',
    'membersUi.import.description': 'Upload a CSV or Excel file, match its columns, check the preview, then save.',
    'membersUi.import.steps': 'Import steps',
    'membersUi.import.step.upload': 'Upload',
    'membersUi.import.step.map': 'Match columns',
    'membersUi.import.step.preview': 'Preview',
    'membersUi.import.step.confirm': 'Import',
    'membersUi.import.upload.label': 'Spreadsheet file',
    'membersUi.import.upload.button': 'Upload and continue',
    'membersUi.import.upload.working': 'Uploading…',
    'membersUi.import.file': '{name}: {count} rows',
    'membersUi.import.hasHeader': 'The first row holds column names',
    'membersUi.import.column': 'Column',
    'membersUi.import.samples': 'Examples',
    'membersUi.import.mapTo': 'Where does {column} go?',
    'membersUi.import.matchBy': 'Match existing members by',
    'membersUi.import.matchBy.email': 'Email',
    'membersUi.import.matchBy.externalId': 'Your reference',
    'membersUi.import.matchBy.fullName': 'Full name',
    'membersUi.import.matchBy.none': 'Do not match (always add)',
    'membersUi.import.updateExisting': 'Update members that already exist',
    'membersUi.import.archiveMissing': 'Archive current members who are not in the file',
    'membersUi.import.dateFormat': 'Date format in the file',
    'membersUi.import.validate': 'Check the file',
    'membersUi.import.validating': 'Checking…',
    'membersUi.import.target.ignore': 'Ignore this column',
    'membersUi.import.target.fullName': 'Full name',
    'membersUi.import.target.firstName': 'First name',
    'membersUi.import.target.lastName': 'Last name',
    'membersUi.import.target.email': 'Email',
    'membersUi.import.target.phone': 'Phone',
    'membersUi.import.target.role': 'Role',
    'membersUi.import.target.externalId': 'Your reference',
    'membersUi.import.target.startDate': 'Start date',
    'membersUi.import.target.endDate': 'End date',
    'membersUi.import.target.status': 'Status',
    'membersUi.import.target.field': 'Field: {label}',
    'membersUi.import.count.create': 'To add',
    'membersUi.import.count.update': 'To update',
    'membersUi.import.count.archive': 'To archive',
    'membersUi.import.count.unchanged': 'Unchanged',
    'membersUi.import.count.errors': 'Problems',
    'membersUi.import.preview.table': 'First rows of the import',
    'membersUi.import.preview.row': 'Row',
    'membersUi.import.preview.action': 'Action',
    'membersUi.import.action.create': 'Add',
    'membersUi.import.action.update': 'Update',
    'membersUi.import.action.archive': 'Archive',
    'membersUi.import.action.unchanged': 'No change',
    'membersUi.import.action.error': 'Problem',
    'membersUi.import.errors.title': 'Problems found',
    'membersUi.import.errors.hint': 'Rows with problems are skipped. Fix them in your file and upload again, or carry on without them.',
    'membersUi.import.errors.row': 'Row {row}',
    'membersUi.import.errors.download': 'Download problems as CSV',
    'membersUi.import.errors.csvHeader': 'Row,Column,Problem',
    'membersUi.import.confirm': 'Import now',
    'membersUi.import.nothing': 'There is nothing to import.',
    'membersUi.import.cancel': 'Cancel import',
    'membersUi.import.progress': 'Importing…',
    'membersUi.import.done': 'Import finished.',
    'membersUi.import.failed': 'The import failed.',
    'membersUi.import.cancelled': 'The import was cancelled.',
    'membersUi.import.backToMembers': 'Back to members',
};
//# sourceMappingURL=w2.js.map